// src/utils/desktopApp.js
// Detect if the app is running inside the Electron desktop wrapper.

/**
 * Returns true when the React app is loaded inside the LMS Campus
 * Electron desktop app.  Detection is two-pronged:
 *  1. User-Agent contains "LMSCampusDesktop"
 *  2. Preload script sets window.lmsCampusDesktop.isDesktopApp
 */
export const isDesktopApp = () => {
  if (typeof window === 'undefined') return false;
  if (window.lmsCampusDesktop?.isDesktopApp === true) return true;
  if (navigator.userAgent.includes('LMSCampusDesktop')) return true;
  return false;
};
